import { useState } from 'react';
import Navbar from './components/Navbar';
import ModuleHero from './components/ModuleHero';
import LessonsList from './components/LessonsList';
import LessonContent from './components/LessonContent';
import ModuleSummary from './components/ModuleSummary';
import PracticalChecklist from './components/PracticalChecklist';
import SelfAssessment from './components/SelfAssessment';
import Footer from '../../pages/home/components/Footer';
import { lessonsData } from './data/lessonsData';

function Module3Page() {
  const [selectedLesson, setSelectedLesson] = useState<number | null>(null);
  const [showSummary, setShowSummary] = useState(false);
  const [showChecklist, setShowChecklist] = useState(false);
  const [showAssessment, setShowAssessment] = useState(false);

  const handleLessonSelect = (lessonId: number) => {
    setSelectedLesson(lessonId);
    setShowSummary(false);
    setShowChecklist(false);
    setShowAssessment(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleShowSummary = () => {
    setSelectedLesson(null);
    setShowSummary(true);
    setShowChecklist(false);
    setShowAssessment(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleShowChecklist = () => {
    setSelectedLesson(null);
    setShowSummary(false);
    setShowChecklist(true);
    setShowAssessment(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleShowAssessment = () => {
    setSelectedLesson(null);
    setShowSummary(false);
    setShowChecklist(false);
    setShowAssessment(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentLesson = selectedLesson 
    ? lessonsData.find(lesson => lesson.id === selectedLesson)
    : null;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ModuleHero />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <div className="sticky top-24">
              <LessonsList 
                lessons={lessonsData}
                selectedLesson={selectedLesson}
                onLessonSelect={handleLessonSelect}
                onShowSummary={handleShowSummary}
                onShowChecklist={handleShowChecklist}
                onShowAssessment={handleShowAssessment}
              />
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-3">
            {!selectedLesson && !showSummary && !showChecklist && !showAssessment && (
              <div className="bg-gradient-to-br from-[#1A3A2E] to-[#0F2419] rounded-xl p-12 text-center">
                <i className="ri-book-open-line text-6xl text-[#39FF14] mb-6"></i>
                <h2 className="text-3xl font-bold text-white mb-4">
                  Módulo 3: Metodologías de Entrenamiento
                </h2>
                <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto">
                  Selecciona una lección del menú lateral para comenzar tu aprendizaje sobre las principales metodologías de entrenamiento y cómo aplicarlas según tu perfil y objetivos.
                </p>
                <div className="flex flex-wrap justify-center gap-4">
                  <button
                    onClick={() => handleLessonSelect(1)}
                    className="px-6 py-3 bg-[#39FF14] text-[#1A3A2E] rounded-lg font-semibold hover:bg-[#2de00f] transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Comenzar con Lección 1
                  </button>
                  <button
                    onClick={handleShowSummary}
                    className="px-6 py-3 bg-white/10 text-white rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Ver Resumen del Módulo
                  </button>
                </div>
              </div>
            )}

            {currentLesson && (
              <LessonContent lesson={currentLesson} />
            )}

            {showSummary && <ModuleSummary />}
            {showChecklist && <PracticalChecklist />}
            {showAssessment && <SelfAssessment />}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Module3Page;